import * as Yup from "yup";
import constant from "./constants";

export const loginSchema = Yup.object({
  email: Yup.string()
    .required("Please enter your email.")
    .matches(
      /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm,
      "Enter a valid email format"
    ),

  password: Yup.string()
    .required("Please enter your password.")
    .matches(/^\S*$/, {
      message: "Invalid Password",
    }),
});

export const TagMeetingValidationSchema = Yup.object({
  startPoint: Yup.string().required("Please select start point"),
  type: Yup.string().required("Please Select Meeting Type"),
  imdCode: Yup.string().when("type", {
    is: (type) => type !== constant.meetingTypeNew,
    then: (schema) => schema.required("Please Enter IMD Code"),
  }),
  imdName: Yup.string().required("Please Enter IMD Name"),
  meetingWith: Yup.string().required("Please Enter Meeting with"),
  purpose: Yup.string().required("Please Enter Purpose"),
  remarks: Yup.string().required("Please Enter Remarks"),
  status: Yup.string().required("Please Select status"),
  // hours: Yup.string().required("Please Select Hours"),
  mins: Yup.string().required("Please Select Minutes"),
  pincode: Yup.number()
    .typeError("Pincode must be a number")
    .min(100000, "Invalid Pincode")
    .max(999999, "Invalid Pincode"),
});

export const RegularizeMeetingValidationSchema = Yup.object({
  startPoint: Yup.string().required("Please select start point"),
  type: Yup.string().required("Please Select Meeting Type"),
  imdCode: Yup.string().when("type", {
    is: (type) => type !== constant.meetingTypeNew,
    then: (schema) => schema.required("Please Enter IMD Code"),
  }),
  imdName: Yup.string().required("Please Enter IMD Name"),
  meetingWith: Yup.string().required("Please Enter Meeting with"),
  purpose: Yup.string().required("Please Enter Purpose"),
  remarks: Yup.string().required("Please Enter Remarks"),
  status: Yup.string().required("Please Select status"),
  // hours: Yup.string().required("Please Select Hours"),
  mins: Yup.string().required("Please Select Minutes"),
  endPoint: Yup.string().required("Please Select Area of Partner"),
  pincode: Yup.number()
    .typeError("Pincode must be a number")
    .min(100000, "Invalid Pincode")
    .max(999999, "Invalid Pincode"),
});

export const forgotSchema = Yup.object({
  email: Yup.string()
    .required("Please enter your email.")
    .matches(
      /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm,
      "Enter a valid email format"
    ),
});

export const resetSchema = Yup.object({
  password: Yup.string()
    .required("Please enter your password.")
    .matches(/^\S*$/, {
      message: "Invalid Password",
    }),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
});

export const markMyDaySchema = Yup.object({
  dayType: Yup.string().required("Please Select a Day Type"),
  activity: Yup.string().required("Please Select Activity"),
  comments: Yup.string().required("Please Enter Remarks"),
});

export const addConveyanceSchema = Yup.object({
  date: Yup.date().required("Please Select a Date"),
  meeting: Yup.string().required("Please Select a Meeting"),
  vehical_type: Yup.string().required("Please Select a Vehicle Type"),
});

export const userFormSchema = Yup.object({
  name: Yup.string().required("Please enter your name."),
  mobile: Yup.string()
    .required("Please enter your mobile.")
    .matches(/^[0-9]{10}$/, "Please enter a valid mobile"),

  email: Yup.string()
    .required("Please enter your email.")
    .matches(
      /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm,
      "Enter a valid email format"
    ),

  // password: Yup.string()
  //   .required("Please enter your password.")
  //   .matches(/^\S*$/, {
  //     message: "Invalid Password",
  //   }),
  userRole: Yup.string().required("Please enter user role."),
  channel: Yup.string().required("Please enter channel."),
  reportingManagerId: Yup.object().required(
    "Please enter reporting manager name."
  ),
  employeeId: Yup.string().required("Please enter your name."),
});

export const userDeleteSchema = Yup.object({
  email: Yup.object().required("Please enter user email."),
});
